export default __webpack_public_path__ + "static/media/goku.7fc0276d.png";